import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ValidationService {
  updateControlValidity(input: UntypedFormGroup | UntypedFormArray | UntypedFormControl): void {
    if (input instanceof UntypedFormControl) {
      input.markAsTouched();
      input.updateValueAndValidity();
      return;
    }
    Object.keys(input.controls).forEach((key: string) => {
      const abstractControl = input.controls[key];
      this.updateControlValidity(abstractControl);
    });
  }
}
